module.exports = __webpack_public_path__ + "img/sw02.8979b899.jpg";